import _ from 'lodash';

import { ATTRIBUTES, DEFAULT_ATTRIBUTE } from '../constants';

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'selectedLabel' implicitly has an 'any' type.
const getRemainingVariants = (selectedLabel, selectedOption, variants) => {
  const selectedAttribute = _.find(ATTRIBUTES, { name: selectedLabel });
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: 'selectedAttribute' is possibly 'undefined'.
  if (selectedAttribute.handle === DEFAULT_ATTRIBUTE.handle) {
    return _.filter(variants, (variant) => variant.redbookCode === _.get(selectedOption, 'redbookCode'));
  }
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: 'selectedAttribute' is possibly 'undefined'.
  return _.filter(variants, (variant) => variant[selectedAttribute.handle] === _.get(selectedOption, 'value'));
};

export default getRemainingVariants;
